module.exports = __webpack_public_path__ + "img/ye.efd1cd0a.svg";